import React from "react";
import Footer from "../components/Footer";
import ResponsiveNav from "../components/ResponsiveNav";
import "bootstrap/dist/css/bootstrap.min.css";

import { Outlet } from "react-router-dom";

import { useLocation } from "react-router-dom";

function Layout(props) {
    const location = useLocation();

    let dripClasses = `fixed top-11 -left-10 md:-left-12 w-52 md:w-64 lg:w-64  z-20`;
    //remove drip in map view
    if (location.pathname === "/contact") {
        // dripClasses += " hidden";
    }

    return (
        <div className="relative flex flex-col  h-screen min-w-screen bg-peachLightPink">
            <ResponsiveNav />
            <img className={dripClasses} src="/images/drip.png" alt="" />

            <main
                id="scrollable-content"
                className="flex-grow overflow-y-auto overflow-x-hidden flex flex-col"
            >
                <div className="flex-grow">
                    <Outlet />
                </div>
                <Footer />
            </main>
        </div>
    );
}

export default Layout;
